// Select the highest-priority unexpired code; presentation belongs to membership-referral.js.
function selectRewardCode(accountInfo, now = Date.now()) {
  function codePriority(record) {
    const noMinimum = Number(record.extra?.min_subtotal_usd) === 0;
    switch (record.extra?.type) {
      case "percent_discount": return noMinimum ? 0 : 1;
      case "fixed_discount": return noMinimum ? 2 : 4;
      case "product_variant":
      case "free_product":
      case "product_variants": return 3;
      // Shipping was omitted from the specified ranking; keep it below those types.
      case "free_shipping": return 5;
      default: return 6;
    }
  }

  const records = Array.isArray(accountInfo?.codeRecords) ? accountInfo.codeRecords : [];
  const codes = records.filter((record) =>
    record && String(record.code || "").trim() && new Date(record.expiredAt).getTime() > now
  );
  codes.sort((a, b) => codePriority(a) - codePriority(b) || new Date(a.expiredAt) - new Date(b.expiredAt));
  return codes[0] || null;
}
